import { OrderType as ApiOrderType } from '@/api/spec';
import { Side } from '@/common/constants';
import type { MarketData } from '@/common/MarketData';
import { getSideFromOrderType, getIsCloseFromOrderType, getIsBuyFromOrderType } from 'ui-kit';

export interface ScaledOrderFields {
  side: Side;
  isClose: boolean;
  isBuy: boolean;
  assetDecimals: number;
  quoteDecimals: number;
  assetCurrency: string;
}

export function deriveOrderFields(orderType: ApiOrderType, market?: MarketData | null): ScaledOrderFields {
  return {
    side: getSideFromOrderType(orderType),
    isClose: getIsCloseFromOrderType(orderType),
    isBuy: getIsBuyFromOrderType(orderType),
    assetDecimals: market?.assetDecimals ?? 4,
    quoteDecimals: market?.quoteDecimals ?? 2,
    assetCurrency: market?.symbol ?? '',
  };
}

export function scaleValue(value: number | undefined, decimals: number, defaultValue: number): number;
export function scaleValue(value: number | undefined, decimals: number): number | undefined;
export function scaleValue(value: number | undefined, decimals: number, defaultValue?: number): number | undefined {
  if (!value) return defaultValue;
  return value / 10 ** decimals;
}
